import React from 'react';
import './shopping-car.scss';
import { BLOCKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import ItemShop from '../../atoms/itemShop/item-shop';

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node, next) => <img className="f-shopping-content-product-image" src={node.data.target.fields.file['es-CO'].url} alt={node.data.target.fields.description['es-CO']} />,
    [BLOCKS.PARAGRAPH]: (node, next) => next.toString().length ? <p className="f-shopping-content-product-description" >{next}</p> : undefined
  }
}

const ShoppingCar = ({ samples, jsonProductSelec, removeSample, actionCar, labelButton }) => {
  return (
    <div className="f-shopping" >
      <div className="f-shopping-border" ></div>
      <div className="f-shopping-content" >
        <div className="f-shopping-content-product">
          {documentToReactComponents(jsonProductSelec, options)}
          <span className="f-shopping-content-product-items" >{samples.length}</span>
        </div>
        <div className="f-shopping-content-elements" >
          {samples.map((sample, key) =>
            <ItemShop
              key={key}
              sample={sample}
              actionClose={() => removeSample(sample.id, sample.size)}
            />
          )}
        </div>
        <button onClick={actionCar} className="f-shopping-content-button">{labelButton}</button>
      </div>
    </div>
  )
}

export default ShoppingCar;